import { Directive, inject } from '@angular/core';

import { I18NextPipe } from 'angular-i18next';

const DEF_VALUE_CHECK = 'i18n_def_value_check';

@Directive()
export abstract class OptionalTranslationDirectiveAbstract {
  protected readonly i18next = inject(I18NextPipe);

  protected checkLabel(key: string): boolean {
    // Bug workaround:
    // If current namespace is the default/fallback namespace,
    // I18Next.exists() always returns true.
    // Only workaround is to apply a fallback/default value
    // and check if it'll (not) be returned.
    // Additionally, filter translation consisting of spaces only.
    const translated = key && this.i18next.transform(key, { defaultValue: DEF_VALUE_CHECK }).trim();
    return translated ? translated !== DEF_VALUE_CHECK : false;
  }
}
